import {IconButton} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import {UserCanAny} from '../UserCan';

type Props = {
  filename: string;
  url: string;
  disabled?: boolean;
};

const DownloadButton = ({filename, url, disabled = false}: Props) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Download failed:', error);
    }
  };

  return (
    <UserCanAny scope='is-admin,staff'>
      <IconButton
        onClick={handleDownload}
        disabled={disabled}
        aria-label={`Download ${filename}`}
        title='Download song'
        sx={{
          minWidth: '24px !important',
          minHeight: '24px !important',
          width: '24px',
          height: '24px',
          p: '2px',
        }}>
        <DownloadIcon />
      </IconButton>
    </UserCanAny>
  );
};

export default DownloadButton;
